namespace('compass.hotel');

compass.hotel.SharesWidget = compass.defineWidget(function SharesWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom;
	var _settings = options;

	var _roomMatesLabel = _settings.roomMatesLabel;
	if(_settings.translate) {
		var mapNewModelToOldModel = function(roommateBase){
			return {
				'first_name': roommateBase.individualBase.first_name,
				'last_name': roommateBase.individualBase.last_name,
				'email': roommateBase.individualBase.email,
				'share_id': roommateBase.share_id
			};
		};
		_settings.shares = _.map(_settings.shares, function(roommateBase,index) {
			return mapNewModelToOldModel(roommateBase);
		});
	}

	var _shares    = _settings.shares;
	var _shareRows = [];

	var _labels = {
		first_name:{
			label: 'First Name',
			hint: 'A first name is required'
		},
		last_name:{
			label: 'Last Name',
			hint: 'A last name is required'
		},
		email: {
			label: 'Email',
			hint: 'A valid email address is required'
		}
	};

	var _grabValues = function (index) {
		var getShare = function (originalValue, index) {
			var fieldSet = _shareRows[index];
			if (fieldSet.hasClass('readOnly')) {
				return originalValue;
			} else {
				return {
					'first_name': fieldSet.find('.first_name').val(),
					'last_name': fieldSet.find('.last_name').val(),
					'email': fieldSet.find('.email').val(),
					'share_id': parseInt(fieldSet.find('.share_id').val(), 10)
				};
			}
		};

		if (typeof index === 'undefined') {
			return _.map(_shares, getShare);
		} else {
			return getShare(_shares[index], index);
		}
	};
	me.grabValues = _grabValues;

	var _clear = me.clear = function () {
	};

	var _readOnly = me.readOnly = function (newShares) {
		// if an argument is passed in and is an array, means the shares were changed elsewhere
		if ($j.isArray(newShares) && newShares.length) {
			_.each(newShares, function (share, i) {
				var index;
				_.find(_shareRows, function (row, i) {
					if (row.hasClass('readOnly')) {
						return false;
					}

					var res = row.find('.first_name').val() === share.first_name &&
						row.find('.last_name').val() === share.last_name &&
						row.find('.email').val() === share.email;

					if (res) { index = i; }
					return res;
				});

				if (typeof index === 'undefined') {
					index = i;
				}

				var row = _shareRows[index];
				_shares[index] = share;

				var newRow = _buildReadOnly(share, index);
				newRow.insertAfter(row);
				row.remove();
				_shareRows[index] = newRow;
			});

			return;
		}

		_.each(_shareRows, function (row, index) {
			var newRow;
			if (row.hasClass('readOnly')) {
				if (!_.isArray(newShares) || newShares.length > 0) { return; }
				_shares[index] = {
					'first_name': '',
					'last_name': '',
					'email': _settings.defaultEmail,
					'share_id': '-1'
				};
				newRow = _buildInput(_shares[index], index);
				newRow.insertAfter(row);
				row.remove();
				_shareRows[index] = newRow;
				return;
			}
			if (!_.find(row.find('input'), function (input) {
					return $(input).val().length === 0;
				})) {

				_shares[index] = _grabValues(index);
				newRow = _buildReadOnly(_shares[index], index);
				newRow.insertAfter(row);
				row.remove();
				_shareRows[index] = newRow;
			}
		});
	};

	var _render = me.render = function (widgetElem) {
		while (_settings.numberOfShares > _shares.length) {
			_shares.push({
				'first_name': '',
				'last_name': '',
				'email': _settings.defaultEmail,
				'share_id': '-1'
			});
		}

		_.each(_shares, function () {
			widgetElem.append(_drawShare.apply(this, arguments));
		});
		me.find('input[placeholder], textarea[placeholder]').placeholderEnhanced();
	};

	var _buildInput = function (share, index) {
		var input = function (className, label, value) {
			var inputField;
			if (_settings.inlineLabels) {
				inputField = d.input({
					type: 'text',
					name: className,
					className: className + " inline",
					value: value,
					placeholder: label,
					autcomplete: 'off',
					'data-parsley-error-message': _labels[className].hint,
					'data-parsley-required': 'false'
				});
				if (className === 'email') {
					inputField.attr({ 'data-parsley-type': 'email' });
				} else {
					inputField.attr({ 'data-parsley-pattern': /[^\d\s\.]/ });  //Contains at least 1 alpha 
				}
				return inputField;
			} else {
				inputField = d.input({
					type: 'text',
					name: className,
					className: className,
					value: value,
					autcomplete: 'off',
					'data-parsley-error-message': _labels[className].hint,
					'data-parsley-required': 'false'
				});
				if (className === 'email') {
					inputField.attr({ 'data-parsley-type': 'email' });
				} else {
					inputField.attr({ 'data-parsley-pattern': /[^\d\s\.]/ });  //Contains at least 1 alpha 
				}
				return d.fieldLabelPair({
					className: className,
					label: label
				}, inputField);
			}
		};

		var firstNameField = input('first_name', _labels.first_name.label, share.first_name).data("hint", _labels.first_name.hint);
		var lastNameField  = input('last_name', _labels.last_name.label, share.last_name).data("hint", _labels.last_name.hint);
		var emailField     = input('email', _labels.email.label, share.email).data("hint", _labels.email.hint);
		var roomMateLabel  = _roomMatesLabel ? d.div({ className: 'roomMateLabel'},'Roommate ' + (index+1)) : d.div();

		firstNameField.change(function() {
			me.trigger('SharesWidget.fieldChanged');
		});

		lastNameField.change(function() {
			me.trigger('SharesWidget.fieldChanged');
		});

		emailField.change(function() {
			me.trigger('SharesWidget.fieldChanged');
		});

		var shareRow = d.div({ className: 'shareRow' },
			roomMateLabel,
			firstNameField,
			lastNameField,
			emailField,
			d.input({
				type: 'hidden',
				name: 'share_id', className: 'share_id',
				value: share.share_id
			}),
			_endDiv()
		);
		_shareRows.push(shareRow);
		return shareRow;
	};

	var _buildReadOnly = function (share, index) {
		var shareRow = d.div({
			className: 'shareRow readOnly'
		}, d.span({
				className: 'fullName readOnly'
			}, share.first_name + " " + share.last_name),
			d.span({
				className: 'email readOnly'
			}, share.email),
			_endDiv()
		);

		_shareRows.push(shareRow);
		return shareRow;
	};

	var _drawShare = function (share, index) {
		if (_settings.readOnly && share.first_name.length) {
			return _buildReadOnly(share, index);
		} else {
			return _buildInput(share, index);
		}
	};

	var _endDiv = function () {
		return d.div({ className: 'clear' });
	};
}, {
	WUID: 'SHARESWIDGET',
	widgetName: 'SharesWidget',
	readOnly: false,
	inlineLabels: false,
	defaultEmail: '',
	numberOfShares: 0
});
